// R34 — N1-0's BADGE, THE ONE SENTENCE THAT KEEPS AN OLD READING FROM READING AS A CURRENT ONE.
//
// A member whose birth details were reset keeps every reading already made from the old ones; they
// are never rewritten and never quietly deleted. But a reading about a DIFFERENT set of details must
// never be mistaken for a reading about who she is now, so it says so — on the shelf and in My Room,
// from the one component.
//
// It moved out here for the reason every extraction on roadmap 7 has: props in, tree out, no hook,
// so a gate can CALL it. Until R34 the whole law was held by `scripts/n1-0-owner-reset-verify.mjs`,
// which needs a live Postgres, a running server and a real Chrome, and is in no gate at all.
//
// TWO THINGS IT DECIDES, and both are member-facing:
//   1. NOTHING RENDERS when the flag is absent or false. It is a badge on a minority of rows, and a
//      badge on every row would say her whole shelf is stale.
//   2. THE TITLE IS THE SENTENCE. "from previous details" alone is machinery; the hover text is what
//      tells her the reading is kept, not broken, and why it is marked.
export function PreviousDetailsBadge({ when }: { when?: boolean }) {
  if (!when) return null;
  return (
    <span className="prev-details" title="Made from your previous birth details, before you updated them.">
      from previous details
    </span>
  );
}
